import { RichText } from 'prismic-reactjs';
import React from 'react';
import htmlSerializer from '../utils/htmlSerializer';
import Image from './image';

const AboutTheSharpener = ({ title, details, image, imageAlt }) => {
  const altText = imageAlt || 'About the sharpener';

  return (
    <div
      id='about the sharpener'
      className='flex w-full flex-col items-center bg-primary text-gray-100'
    >
      <div className='w-full py-12 md:w-2/3'>
        <div className='p-8 text-center md:px-0'>
          <p className='font-display text-2xl md:text-3xl'>{title}</p>
        </div>
        <div className='flex w-full flex-col items-center px-8 md:px-0'>
          <div className='hidden text-justify text-lg md:block md:px-4'>
            <RichText render={details.raw} htmlSerializer={htmlSerializer} />
          </div>
          <div className='text-lg md:hidden'>
            <RichText render={details.raw} htmlSerializer={htmlSerializer} />
          </div>
          <Image
            image={image}
            alt={altText}
            className='rounded md:mt-4 md:w-2/5 md:shadow-lg'
          />
        </div>
      </div>
    </div>
  );
};

export default AboutTheSharpener;
